import { override, makeObservable } from 'mobx'

import SharedStore from 'shared/stores/shared.store'

import { JointVenturesApi, createJointVenturesApi, JointVenture, Params } from '../api/jointVenture-v2.api'

export class JointVenturesV2Store extends SharedStore<JointVenture> {
  storeName = 'JointVenturesV2Store'
  declare childApi: JointVenturesApi

  constructor(root) {
    super()
    this.childApi = createJointVenturesApi(root.apiClient)
    makeObservable(this)
  }
  @override
  async fetchList(): Promise<void> {
    this.toggleLoading(true)

    const { sortDir = 'desc', sortKey = 'id', per, page } = this.queryParams
    const params: Params = {
      page: {
        size: per,
        number: page,
      },
      stats: { total: 'count' },
      sort: sortDir === 'desc' ? `-${sortKey}` : sortKey,
    }

    if (this.queryParams.from && this.queryParams.till) {
      params.filter = {
        created_at: {
          gte: this.queryParams.from,
          lte: this.queryParams.till,
        },
      }
    }

    if (this.queryParams.query) {
      params.query = this.queryParams.query
    }

    const resp = await this.childApi.fetchList(params)

    if (resp.responseType === 'success') {
      this.list = resp.data.map((i) => ({ ...i, id: Number(i.id) }))
      this.updatePagination({ total: resp?.totalCount })
    }

    this.toggleLoading(false)
  }
}
